export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_19-c53c35e2247572163aabf89ff55a0e77.jpg";